import React, { useEffect, useMemo, useState } from 'react';
import { Avatar, Button, Col, Divider, Drawer, Popover, Row, Tooltip } from 'antd';
import {
    AppstoreOutlined, CheckCircleOutlined, ClockCircleOutlined, CloseOutlined, ExclamationCircleOutlined,
    StarOutlined, UserOutlined
} from '@ant-design/icons';
import styles from './style.module.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAuthToken, getCurrentUser } from '../../utils/authHelpers';
import { getRemainingDaysMessage } from '../../utils/helpers';
import { setAllSubscription, setLatestSubscriptions, setSelectedMenu } from '../../features/UserInfo/UserSlice';
import SubscriptionSection from '../../pages/Organizations/Subscriptions/SubscriptionsSection';
import JobSeekerSubscription from '../CommonElements/JobSeekerSubscription';
import { setIsSignIn, setLoggedInUser } from '../../features/Auth/authSlice';
import { setAllSubscriptionorg, setLatestSubscriptionsorg } from '../../features/Organization/OrganizationInfo/OrganizationSlice';
import AppSecureStorage from '../../services/storage/secureStorage';
import { onSetDefaultData } from '../../features/Global/globalSlice';
import PricingComponent from '../../pages/GuestUsers/PricingComponent';
import { setChangesStatus } from '../../features/Organization/OrganizationInfo/OrganizationInfoSlice';
const storage = new AppSecureStorage()
const HeaderDrwaer = ({ setShowMobileMenu, showMobileMenu, navIcons, navItems }) => {
    const loggedInToken = getAuthToken();
    const currentUser = getCurrentUser();
    const dispatch = useDispatch();
    const { userProfile } = useSelector((state) => state.global);
    const [issubscription, setIsSubscription] = useState(false)
    const [issubscriptionJob, setIsSubscriptionJob] = useState(false);
    const [subscription, setSubscription] = useState(userProfile?.subscription);
    const { latestSubscriptionsorg } = useSelector((state) => state.organizationData);
    const { latestSubscriptions, selectedMenu } = useSelector((state) => state.userData);
    const [isPricing, setIsPricing] = useState(false)
    const location = useLocation();
    const navigate = useNavigate();

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const getSubscriptionStyle = (type) => {
        switch (type) {
            case 'premium':
                return {
                    backgroundColor: '#fffbe6',
                    borderColor: '#faad14',
                    color: '#d48806',
                    icon: <StarOutlined />,
                };
            case 'standard':
                return {
                    backgroundColor: '#e6f7ff',
                    borderColor: '#1890ff',
                    color: '#096dd9',
                    icon: <UserOutlined />,
                };
            case 'free':
            default:
                return {
                    backgroundColor: '#f9f0ff',
                    borderColor: '#9254de',
                    color: '#722ed1',
                    icon: <ClockCircleOutlined />,
                };
        }
    };

    const subscriptionType = latestSubscriptionsorg?.type || 'free';
    const subscriptionStyle = getSubscriptionStyle(subscriptionType);

    const getSubscriptionStyleByRemainingDays = (expirationDateTime) => {
        const expiration = new Date(expirationDateTime);
        const today = new Date();
        const diffInDays = Math.ceil((expiration - today) / (1000 * 60 * 60 * 24));

        if (diffInDays > 10) {
            return {
                backgroundColor: '#f6ffed',
                borderColor: '#52c41a',
                color: '#389e0d',
                icon: <CheckCircleOutlined />,
            };
        } else if (diffInDays <= 3) {
            return {
                backgroundColor: '#fff2f0',
                borderColor: '#ff4d4f',
                color: '#cf1322',
                icon: <ExclamationCircleOutlined />,
            };
        } else {
            return {
                backgroundColor: '#fffbe6',
                borderColor: '#faad14',
                color: '#d48806',
                icon: <ClockCircleOutlined />,
            };
        }
    };

    const handleLogout = () => {
        dispatch(setLoggedInUser(null))
        dispatch(setAllSubscription([]))
        dispatch(setLatestSubscriptions([]))
        dispatch(setAllSubscriptionorg([]))
        dispatch(setLatestSubscriptionsorg([]))
        storage.clearStorage();
        navigate('/');
    };

    useEffect(() => {
        dispatch(setSelectedMenu(location.pathname));
    }, [location.pathname]);

    const renderGuestItems = useMemo(() => ([
        {
            label: "Home", key: "/", goToPage: () => {
                navigate("/")
                dispatch(setSelectedMenu('/'))
                dispatch(onSetDefaultData())
            }
        },
        {
            label: "Find Job", key: "/jobseeker", goToPage: () => {
                navigate("/jobseeker")
                dispatch(setSelectedMenu('/jobseeker'))
                dispatch(onSetDefaultData())
            }
        },
        {
            label: "Request Demo", key: "/request-demo", goToPage: () => {
                navigate("/request-demo")
                dispatch(setSelectedMenu('/request-demo'))
                dispatch(onSetDefaultData())
            }
        },
        {
            label: (
                <Popover
                    content={<div className={`titleFont ${styles.pricingPopoverContent}`}><PricingComponent /></div>}
                    trigger="hover"
                    placement="bottom"
                    overlayClassName={styles.pricingPopover}
                >
                    <div
                        onMouseEnter={() => dispatch(setSelectedMenu('/pricing'))}
                        onClick={() => dispatch(setSelectedMenu('/pricing'))}
                        className={`btnfonts `}>
                        Pricing
                    </div>
                </Popover>


                // </Dropdown>
            ),
            key: "/pricing",
            //   goToPage: () => navigate("/pricing")
        }

        ,

        {
            label: "About Us", key: "/about-us", goToPage: () => {
                navigate("/about-us")
                dispatch(setSelectedMenu('/about-us'))
                dispatch(onSetDefaultData())
            }
        },
        {
            label: "Contact Us", key: "/contact-us", goToPage: () => {
                navigate("/contact-us")
                dispatch(setSelectedMenu("/contact-us"))
                dispatch(onSetDefaultData())
            }
        },
    ]), [navigate]);

    const jobSeekerMenuItems = useMemo(() => ([
        {
            label: "Dashboard", key: "/jobseeker/dashboard", goToPage: () => {
                navigate("/jobseeker/dashboard")
                dispatch(onSetDefaultData())
            }
        },
        {
            label: "Tickets", key: "/jobseeker/tickets", goToPage: () => {
                navigate("/jobseeker/tickets")
                dispatch(onSetDefaultData())
            }
        },
        {
            label: "Recommended Jobs", key: "/jobseeker/recommended-jobs", goToPage: () => {
                navigate("/jobseeker/recommended-jobs")
                dispatch(onSetDefaultData())
            }
        },
        {
            label: "Saved Jobs", key: "/jobseeker/save-jobs", goToPage: () => {
                navigate("/jobseeker/save-jobs")
                dispatch(onSetDefaultData())
            }
        },
        {
            label: "References", key: "/jobseeker/reference-people", goToPage: () => {
                navigate("/jobseeker/reference-people")
                dispatch(onSetDefaultData())
            }
        },
        {
            label: "Calender", key: "/jobseeker/calender", goToPage: () => {
                navigate("/jobseeker/calender")
                dispatch(onSetDefaultData())
            }
        },
    ]), [navigate]);

    const orgMenuItems = useMemo(() => ([
        {
            label: "Dashboard", key: "/dashboard", goToPage: () => {
                navigate("/dashboard")
                dispatch(onSetDefaultData());
                dispatch(setChangesStatus('open'))
            }
        },
        {
            label: "Job Status", key: "/job-status", goToPage: () => {
                navigate("/job-status")
                dispatch(onSetDefaultData())
                dispatch(setChangesStatus('open'))
            }
        },
        {
            label: "Recommend Candidate", key: "/recommend-candidate", goToPage: () => {
                navigate("/recommend-candidate")
                dispatch(onSetDefaultData())
                dispatch(setChangesStatus('open'))
            }
        },
        // { label: "Analytics", key: "/analytics", goToPage: () => navigate("/analytics") },
        {
            label: "Calender", key: "/organization-calender", goToPage: () => {
                navigate("/organization-calender")
                dispatch(onSetDefaultData())
                dispatch(setChangesStatus('open'))
            }
        },
    ]), [navigate]);

    // const navItems = loggedInToken
    //     ? (currentUser === 'organization' ? orgMenuItems : jobSeekerMenuItems)
    //     : renderGuestItems;

    useEffect(() => {
        dispatch(setSelectedMenu(location.pathname));
    }, [location.pathname]);

    return (
        <div>
            <Drawer
                closable={false}
                extra={
                    <Avatar onClick={() => setShowMobileMenu(false)} size={'small'} className='bg-white text-black add-cursor' icon={<CloseOutlined />} />
                }
                title={
                    <div onClick={() => navigate('/')} className='add-cursor' style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <Avatar src={"https://eployrs-config-file.s3.ap-south-1.amazonaws.com/eployrs/Images/logo/LOGO_ICON_BLACK_V01.jpg"} size={32} />
                        <span className="btnfonts" style={{ fontSize: 18 }}>
                            <div className='btnfonts'>EPLOYRS </div>
                            <div className='logofulname'>(Bridging Talent and Oppertinity smarter with AI)</div>
                        </span>
                    </div>
                }
                placement="left"
                onClose={() => setShowMobileMenu(false)}
                open={showMobileMenu}
                width={270}
                className={styles.mobileDrawer}
            >
                <div className={styles.drawerMenuContent}>
                    {navItems.map((item) => (
                        <div key={item.key} className={selectedMenu === item?.key ? styles.activedrawerMenuItem : styles.drawerMenuItem} onClick={() => {
                            item?.goToPage()
                            setShowMobileMenu(false);
                        }}>
                            {navIcons[item.key] || <AppstoreOutlined />} <span className={styles.drawrrLabel}>{item.label}</span>
                        </div>
                    ))}

                    <div className={`${styles.headerActivationSection}`}>
                        <Divider />

                        {
                            windowWidth < 495 && <>{loggedInToken &&
                                <div className='mb10' style={windowWidth <= 832 ? { flex: '1 1 50px' } : { flex: '1 1 200px' }}>

                                    {currentUser === "organization" ?
                                        <div>
                                            <>
                                                <Row align="middle" justify="space-between" gutter={[16, 16]}>
                                                    {latestSubscriptionsorg?.name ? (
                                                        <Col>
                                                            <Tooltip title={`Remaining Posts: ${userProfile?.remainingJDPlans}`}>
                                                                <Button
                                                                    type="default"
                                                                    size='small'
                                                                    onClick={() => {
                                                                        setIsSubscription(true);
                                                                    }}
                                                                    style={{
                                                                        ...getSubscriptionStyleByRemainingDays(latestSubscriptionsorg?.expirationDateTime),
                                                                        fontWeight: 600,
                                                                        padding: windowWidth <= 344 ? '15px 1px' : '15px 20px',
                                                                        borderRadius: '25px',
                                                                        boxShadow: '0 3px 10px rgba(0, 0, 0, 0.15)',
                                                                        cursor: 'pointer',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '8px',
                                                                    }}
                                                                >
                                                                    {windowWidth >= 500 && subscriptionStyle.icon}
                                                                    <span className='text-uppercase'>
                                                                        {latestSubscriptionsorg?.type} <span style={windowWidth <= 832 ? { display: 'none' } : {}}>
                                                                            | {" "}
                                                                            {getRemainingDaysMessage(latestSubscriptionsorg?.expirationDateTime)}
                                                                        </span>
                                                                    </span>
                                                                </Button>
                                                            </Tooltip>
                                                        </Col>
                                                    ) :

                                                        <Col>
                                                            <Button
                                                                type="primary"
                                                                shape='round'
                                                                size='large'
                                                                onClick={() => setIsSubscription(true)}
                                                                className='blueGradiant'
                                                            >
                                                                Activate Subscription Plan
                                                            </Button>
                                                        </Col>
                                                    }
                                                </Row>
                                            </>

                                        </div> :
                                        <div>
                                            {latestSubscriptions?.name ? (
                                                <Button
                                                    type="default"
                                                    size='small'
                                                    onClick={() => setIsSubscriptionJob(true)}
                                                    style={{
                                                        ...getSubscriptionStyleByRemainingDays(latestSubscriptions?.expirationDateTime),
                                                        fontWeight: 600,
                                                        padding: windowWidth <= 344 ? '15px 1px' : '15px 20px',
                                                        borderRadius: '25px',
                                                        boxShadow: '0 3px 10px rgba(0, 0, 0, 0.15)',
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '8px',
                                                    }}
                                                >
                                                    {windowWidth >= 500 && subscriptionStyle.icon}
                                                    <span className='text-uppercase'>
                                                        {latestSubscriptions?.type}
                                                        <span
                                                            style={windowWidth <= 832 ? { display: 'none' }
                                                                : {}}
                                                        > | {' '}
                                                            {getRemainingDaysMessage(latestSubscriptions?.expirationDateTime)} </span>
                                                    </span>
                                                </Button>
                                            ) : (
                                                <Button
                                                    type="primary"
                                                    onClick={() => setIsSubscriptionJob(true)}
                                                    shape='round'
                                                    className='blueGradiant'
                                                >
                                                    Activate Subscription Plan
                                                </Button>
                                            )}
                                        </div>
                                    }
                                </div>


                            }</>
                        }
                        {
                            loggedInToken ?
                                <Button onClick={handleLogout} shape='round' size='large' className='fullwidth darkGradiant text-white'>
                                    Logout
                                </Button>
                                :
                                <Button onClick={() => {
                                    dispatch(setIsSignIn(true))
                                    navigate('/login')
                                }} shape='round' size='large' className='fullwidth darkGradiant text-white'>
                                    Login
                                </Button>
                        }
                    </div>

                </div>

                {/* <SubscriptionSection subscription={subscription} issubscription={issubscription} setIsSubscription={setIsSubscription}
                    setSubscription={setSubscription} />
                <PricingComponent visible={issubscriptionJob} onClose={() => setIsSubscriptionJob(false)} /> */}
                <PricingComponent
                    visible={
                        loggedInToken
                            ? (currentUser === 'organization'
                                ? issubscription
                                : issubscriptionJob)
                            : isPricing
                    }
                    onClose={() => {
                        if (!loggedInToken) return setIsPricing(false);
                        if (currentUser === 'organization') return setIsSubscription(false);
                        return setIsSubscriptionJob(false);
                    }}
                />
            </Drawer>
        </div>
    )
}

export default HeaderDrwaer